export default __webpack_public_path__ + "static/media/pop-art.0f10bd31.jpeg";